const plugins = [
  {
    name: "Credentials",
    released: "16 hours ago",
    description: "This plugin allows you to store credentials in Jenkins.",
    tags: ["Tag 1", "Tag 2", "Tag 3"],
    version: "v1.235.2"
  },
  {
    name: "SSH Credentials",
    released: "16 hours ago",
    description: "Allows storage of SSH credentials in Jenkins",
    tags: ["Tag 1", "Tag 2", "Tag 3"],
    version: "v1.235.2"
  },
  {
    name: "JUnit",
    released: "16 hours ago",
    description: "Allows JUnit-format test results to be published.",
    tags: ["Tag 1", "Tag 2", "Tag 3"],
    version: "v1.235.2"
  },
  {
    name: "GitHub",
    released: "16 hours ago",
    description: "Integrates GitHub into Jenkins",
    tags: ["Tag 1", "Tag 2", "Tag 3"],
    version: "v1.235.2"
  }
]

export default plugins;
